import PropTypes from 'prop-types';
import React from 'react';

function Transcript(props) {
  const { fill } = props;
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_21670_235862)">
        <path
          d="M11.375 18.8759H3.875C3.54348 18.8759 3.22554 18.7442 2.99112 18.5097C2.7567 18.2753 2.625 17.9574 2.625 17.6259V3.87585C2.625 3.54433 2.7567 3.22639 2.99112 2.99197C3.22554 2.75755 3.54348 2.62585 3.875 2.62585H12.7325C13.0639 2.62615 13.3816 2.75803 13.6158 2.99252L16.0092 5.38502C16.1252 5.50115 16.2173 5.63901 16.28 5.79071C16.3428 5.94242 16.3751 6.10501 16.375 6.26919V8.25002"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M5.125 7.625H13.875"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M5.125 11.375H11.375"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M5.125 15.125H8.25"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M17.4321 19.5375V21.3808"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M17.6098 10.7509H17.1747C16.2134 10.7509 15.4341 11.5302 15.4341 12.4915V15.6463C15.4341 16.6076 16.2134 17.3869 17.1747 17.3869H17.6098C18.5711 17.3869 19.3504 16.6076 19.3504 15.6463V12.4915C19.3504 11.5302 18.5711 10.7509 17.6098 10.7509Z"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M13.5 14.7448V15.8508C13.5 16.8285 13.8884 17.7663 14.5798 18.4577C15.2712 19.1491 16.2089 19.5375 17.1867 19.5375H17.6782C18.656 19.5375 19.5937 19.1491 20.2851 18.4577C20.9765 17.7663 21.3649 16.8285 21.3649 15.8508V14.7448"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
      </g>
      <defs>
        <clipPath id="clip0_21670_235862">
          <rect fill="white" height="20" transform="translate(2 2)" width="20" />
        </clipPath>
      </defs>
    </svg>
  );
}

Transcript.propTypes = {
  fill: PropTypes.string.isRequired
};

export default Transcript;
